const QUEST_JOURNAL_SELECTED_DATE_KEY = "vocabularium_quest_journal_selected_date";
const QUEST_JOURNAL_LAST_SEEN_ACTIVE_DATE_KEY =
  "vocabularium_quest_journal_last_seen_active_date";
const QUEST_JOURNAL_SIDEBAR_SCROLL_KEY = "vocabularium_quest_journal_sidebar_scroll";
const QUEST_JOURNAL_DETAIL_SCROLL_KEY = "vocabularium_quest_journal_detail_scroll";

function readJsonMap(storageKey) {
  try {
    const raw = localStorage.getItem(storageKey);
    const parsed = raw ? JSON.parse(raw) : {};
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

export function readQuestJournalSelectedDate() {
  try {
    const value = localStorage.getItem(QUEST_JOURNAL_SELECTED_DATE_KEY);
    return value || null;
  } catch {
    return null;
  }
}

export function writeQuestJournalSelectedDate(date) {
  try {
    if (date) {
      localStorage.setItem(QUEST_JOURNAL_SELECTED_DATE_KEY, date);
    } else {
      localStorage.removeItem(QUEST_JOURNAL_SELECTED_DATE_KEY);
    }
  } catch {
    // ignore storage errors
  }
}

export function readQuestJournalLastSeenActiveDate() {
  try {
    const value = localStorage.getItem(QUEST_JOURNAL_LAST_SEEN_ACTIVE_DATE_KEY);
    return value || null;
  } catch {
    return null;
  }
}

export function writeQuestJournalLastSeenActiveDate(date) {
  try {
    if (date) {
      localStorage.setItem(QUEST_JOURNAL_LAST_SEEN_ACTIVE_DATE_KEY, date);
    } else {
      localStorage.removeItem(QUEST_JOURNAL_LAST_SEEN_ACTIVE_DATE_KEY);
    }
  } catch {
    // ignore storage errors
  }
}

export { resolveQuestJournalSelectedDate } from "./questJournalSelection";

export function readQuestJournalSidebarScroll() {
  try {
    const value = Number(localStorage.getItem(QUEST_JOURNAL_SIDEBAR_SCROLL_KEY));
    return Number.isFinite(value) && value >= 0 ? value : 0;
  } catch {
    return 0;
  }
}

export function writeQuestJournalSidebarScroll(scrollTop) {
  try {
    const value = Math.max(0, Number(scrollTop) || 0);
    localStorage.setItem(QUEST_JOURNAL_SIDEBAR_SCROLL_KEY, String(value));
  } catch {
    // ignore storage errors
  }
}

export function readQuestJournalDetailScrollMap() {
  return readJsonMap(QUEST_JOURNAL_DETAIL_SCROLL_KEY);
}

export function readQuestJournalDetailScroll(date) {
  if (!date) return 0;
  const map = readQuestJournalDetailScrollMap();
  const value = Number(map[date]);
  return Number.isFinite(value) && value >= 0 ? value : 0;
}

export function writeQuestJournalDetailScroll(date, scrollTop) {
  if (!date) return;

  try {
    const map = readQuestJournalDetailScrollMap();
    map[date] = Math.max(0, Number(scrollTop) || 0);
    localStorage.setItem(QUEST_JOURNAL_DETAIL_SCROLL_KEY, JSON.stringify(map));
  } catch {
    // ignore storage errors
  }
}

const QUEST_JOURNAL_FILTERS_KEY = "vocabularium_quest_journal_filters";
const QUEST_JOURNAL_SEARCH_KEY = "vocabularium_quest_journal_search";
const QUEST_JOURNAL_SEARCH_SCOPE_KEY = "vocabularium_quest_journal_search_scope";

export const QUEST_JOURNAL_SEARCH_SCOPES = {
  TITLE: "title",
  CONTENT: "content",
};

export function readQuestJournalFilters() {
  try {
    const raw = localStorage.getItem(QUEST_JOURNAL_FILTERS_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch {
    return null;
  }
}

export function writeQuestJournalFilters(filters) {
  try {
    localStorage.setItem(QUEST_JOURNAL_FILTERS_KEY, JSON.stringify(filters));
  } catch {
    // ignore storage errors
  }
}

export function readQuestJournalSearchQuery() {
  try {
    return localStorage.getItem(QUEST_JOURNAL_SEARCH_KEY) || "";
  } catch {
    return "";
  }
}

export function writeQuestJournalSearchQuery(query = "") {
  try {
    const value = typeof query === "string" ? query : "";
    if (value.trim()) {
      localStorage.setItem(QUEST_JOURNAL_SEARCH_KEY, value);
    } else {
      localStorage.removeItem(QUEST_JOURNAL_SEARCH_KEY);
    }
  } catch {
    // ignore storage errors
  }
}

export function readQuestJournalSearchScope() {
  try {
    const value = localStorage.getItem(QUEST_JOURNAL_SEARCH_SCOPE_KEY);
    return value === QUEST_JOURNAL_SEARCH_SCOPES.CONTENT
      ? QUEST_JOURNAL_SEARCH_SCOPES.CONTENT
      : QUEST_JOURNAL_SEARCH_SCOPES.TITLE;
  } catch {
    return QUEST_JOURNAL_SEARCH_SCOPES.TITLE;
  }
}

export function writeQuestJournalSearchScope(scope = QUEST_JOURNAL_SEARCH_SCOPES.TITLE) {
  try {
    const value =
      scope === QUEST_JOURNAL_SEARCH_SCOPES.CONTENT
        ? QUEST_JOURNAL_SEARCH_SCOPES.CONTENT
        : QUEST_JOURNAL_SEARCH_SCOPES.TITLE;
    localStorage.setItem(QUEST_JOURNAL_SEARCH_SCOPE_KEY, value);
  } catch {
    // ignore storage errors
  }
}
